export default __webpack_public_path__ + "static/media/slate.5e17d8a7.png";